// # Filename: src/components/poker/shared/PokerFeltInfo.jsx
// Pot total + blinds/phase readouts shown in the center of the felt, identical for
// every breakpoint.

import React from "react";
import { LuCircleDollarSign } from "react-icons/lu";

export function FeltInfoPanel({ game, displayPot = null }) {
  return (
    <div className="z-30 flex items-center justify-center gap-1 px-2 text-center text-[10px] font-black uppercase tracking-[0.08em] text-emerald-50 sm:text-xs">
      <span>Pot Total:</span>
      <LuCircleDollarSign size={12} className="shrink-0 text-amber-200/85" />
      <span>{displayPot ?? game?.pot ?? 0}</span>
    </div>
  );
}

export function FeltRoundMeta({ game }) {
  return (
    <div className="z-30 flex items-center justify-center gap-3 whitespace-nowrap text-[9px] font-semibold uppercase leading-tight tracking-[0.08em] text-emerald-50/68 sm:gap-4">
      <span>Blinds: {game?.small_blind || 0}/{game?.big_blind || 0}</span>
      <span className="h-1 w-1 rounded-full bg-emerald-50/35" />
      <span>{game?.phase || "preflop"}</span>
    </div>
  );
}
